type UploadInvoice = () => Promise<string>;

interface StartInvoiceUploadsParams {
  userPermission: boolean;
  fortlev?: boolean;
  handleUpload: UploadInvoice;
  handleUploadMerx: UploadInvoice;
  handleUploadFortlev: UploadInvoice;
}

export function startInvoiceUploads({
  userPermission,
  fortlev,
  handleUpload,
  handleUploadMerx,
  handleUploadFortlev,
}: StartInvoiceUploadsParams): void {
  const upload = fortlev
    ? handleUploadFortlev()
    : userPermission
    ? handleUploadMerx()
    : handleUpload();

  void upload.catch((error) => {
    console.error(error);
  });
}
